import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <FooterContainer>
      <p>
        <a href="https://www.unfamiliargroup.com" target="_blank" rel="noopener noreferrer">
          Unfamiliar Group - Empowering Communities
        </a>
      </p>
    </FooterContainer>
  );
};

export default Footer;

// Styled Components
const FooterContainer = styled.footer`
  background: rgba(0, 0, 0, 0.9);
  color: white;
  text-align: center;
  padding: 15px;
  position: relative;
  bottom: 0;
  width: 100%;
  margin-top: 50px;

  a {
    color: #ffd700;
    text-decoration: none;
    font-weight: bold;
  }

  a:hover {
    text-decoration: underline;
  }
`;